<template>
  <el-dropdown class="expression-editor" trigger="click" @command="insertItem">
    <div class="calc-textarea-container">
      <div
        class="textarea"
        :style="{ maxHeight: maxHeight + 'px', lineHeight: lineHeight + 'px' }"
        @keyup="saveCursorPos('keyup')"
        @click="saveCursorPos('click')"
      ></div>
    </div>
    <el-dropdown-menu
      class="calc-var-dropdown-menu"
      slot="dropdown"
      style="min-width: 180px;overflow-y: auto !important;"
    >
      <span class="empty" v-if="_.isEmpty(options)">无可选字段</span>
      <el-dropdown-item v-for="(item, index) in options" :key="index" :command="item">
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { replaceAll } from "@/utils/common"
export default {
  name: "expression-editor",
  props: {
    value: String,
    options: Array,
    maxHeight: {
      type: Number,
      default: 34
    },
    lineHeight: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      localVal: "",
      textareaDom: null,
      emitValDebounced: null
    }
  },
  watch: {
    value() {
      this.drawDom(this.value)
    }
  },
  created() {
    this.emitValDebounced = this._.debounce(this.emitVal, 500)
  },
  mounted() {
    this.textareaDom = this.$el.querySelector(".textarea")
    this.drawDom(this.value)
  },
  methods: {
    drawDom(val) {
      if (this._.isEqual(val, this.localVal)) return
      this.localVal = this.value
      let expression = this.value || ""
      for (let item of this.options) {
        expression = replaceAll(
          expression,
          item.value,
          `<div data-value="${encodeURIComponent(item.value)}">${item.label}</div> `
        )
      }
      this.textareaDom.innerHTML = expression
    },
    // 保存光标位置
    saveCursorPos(from) {
      let selection = window.getSelection ? window.getSelection() : document.selection
      if (!selection.rangeCount) return
      let range = selection.createRange ? selection.createRange() : selection.getRangeAt(0)
      this.rangeStart = range
      if ("keyup" === from) this.emitValDebounced()
    },
    emitVal() {
      this.localVal = [...this.textareaDom.childNodes]
        .map(node => {
          return node.tagName == "DIV"
            ? decodeURIComponent(node.dataset.value.toString())
            : node.textContent.trim()
        })
        .join("")
      this.$emit("input", this.localVal)
    },
    // 插入变量
    insertItem(item) {
      let editDiv = this.textareaDom
      if ("getSelection" in window) {
        let sel = window.getSelection()
        let div = document.createElement("div")
        div.innerHTML = item.label
        div.setAttribute("data-value", encodeURIComponent(item.value))
        if (!this.rangeStart) {
          this.rangeStart = document.createRange()
          this.rangeStart.selectNodeContents(editDiv)
          this.rangeStart.collapse(false)
          sel.removeAllRanges()
          sel.addRange(this.rangeStart)
        }
        this.rangeStart.insertNode(this.rangeStart.createContextualFragment("&nbsp;"))
        this.rangeStart.insertNode(div)
        this.rangeStart.collapse(false) // 对于IE来说，参数不可省略
        sel.removeAllRanges()
        sel.addRange(this.rangeStart)
        editDiv.focus()
      } else if ("selection" in document) {
        editDiv.focus()
        let range = document.selection.createRange()
        range.pasteHTML(
          "<div data-value='" + encodeURIComponent(item.value) + "'>" + item.label + "</div>"
        )
        editDiv.focus() // IE 11模拟的IE5~IE8无须这一步也能获得焦点
      }
      this.emitValDebounced()
    }
  }
}
</script>

<style lang="scss" scoped>
.expression-editor {
  width: 100%;
  display: block;
  .calc-textarea-container {
    display: flex;
    position: relative;
    overflow: hidden;
    .textarea {
      width: 100%;
      padding: 4px 10px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      word-wrap: break-word;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-user-modify: read-write-plaintext-only;
      background-color: #fff;
      &:focus {
        border-color: #409eff;
        outline: none;
      }
      ::v-deep {
        div {
          line-height: 24px;
          display: inline-flex;
          -webkit-user-modify: read-only;
          padding: 0 10px;
          margin: 1px 5px;
          background-color: #01ca83;
          color: #fff;
          border-radius: 14px;
          user-select: none;
          border: 1px solid #9cd7f1;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
.calc-var-dropdown-menu {
  max-height: 500px;
  ::v-deep {
    .empty {
      font-size: 14px;
      display: inline-block;
      text-align: center;
      width: 100%;
    }
  }
}
</style>
